import { render } from "./g-galleria.vue?vue&type=template&id=0b788d45&scoped=true"
import script from "./g-galleria.vue?vue&type=script&lang=js"
export * from "./g-galleria.vue?vue&type=script&lang=js"

import "./g-galleria.vue?vue&type=style&index=0&id=0b788d45&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b788d45"]])

export default __exports__